import { render, staticRenderFns } from "./MotionZonesCanvas.vue?vue&type=template&id=6b2f803e&"
import script from "./MotionZonesCanvas.vue?vue&type=script&lang=js&"
export * from "./MotionZonesCanvas.vue?vue&type=script&lang=js&"
import style0 from "./MotionZonesCanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2f803e')) {
      api.createRecord('6b2f803e', component.options)
    } else {
      api.reload('6b2f803e', component.options)
    }
    module.hot.accept("./MotionZonesCanvas.vue?vue&type=template&id=6b2f803e&", function () {
      api.rerender('6b2f803e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Device/Settings/MotionZones/MotionZonesCanvas.vue"
export default component.exports